import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import ApproveData from "../ApproveRegister/ApproveData";
import ApproveMasterData from "../ApproveRegister/ApproveMasterData";

function RegSugarRoundTab() {
  return (
    <>
      <Tabs
        defaultActiveKey="farmer"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="farmer" title="ชาวไร่อ้อย">
          <ApproveData />
        </Tab>
        <Tab eventKey="farmer-master" title="หัวหน้ากลุ่มชาวไร่อ้อย">
          <ApproveMasterData />
        </Tab>
      </Tabs>
    </>
  );
}

export default RegSugarRoundTab;
